export default __webpack_public_path__ + "static/media/srisailamDeitieThree.92123cff.png";